import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup } from '@angular/forms';
import { first } from 'rxjs/operators';
import { ReportService } from '@app/_components/report';
import { TagService } from '../../task/tag/tag.service';
import { TagJoinService } from './../tag-join/tag-join.service';
import { AlertService } from '@app/_services';
import { TagAddModalComponent } from '@app/_components/task/tag/tag-add-modal/tag-add-modal.component';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-tag-join-list-select',
    templateUrl: './tag-join-list.component.html',
    styleUrls: ['./tag-join-list.component.css'],
    standalone: false
})
export class TagJoinListComponent implements OnInit, OnChanges
{
	texts: string[] = [];

	tagSuggestions: string[];

	tagSelectForm: UntypedFormGroup;

	tagAddModalDialogRef: MatDialogRef<TagAddModalComponent>;

	@Output() messageEvent = new EventEmitter<string>();

	@Input() tagType: number;
	// inputs
	@Input() tagSource: number;
	@Input() tagSourceId: number;
	tags: any;
  @Input() loadedTags: any;



	constructor(
		private formBuilder: UntypedFormBuilder,
		private reportService: ReportService,
		private tagService: TagService,
		private tagJoinService: TagJoinService,
		private alertService: AlertService,
		private dialog: MatDialog) { }

	ngOnInit()
	{
		this.tagSelectForm = this.formBuilder.group({
			tagSource: this.tagSource,
			tagSourceId: this.tagSourceId
		});
    if ( this.loadedTags ){
      this.tags = this.loadedTags;
      this.tagSelectForm.patchValue({ tagJoin: this.tags });
    }
    else{
      this.findTags();
    }
	}

	findTags() {
		this.tagJoinService.getTagByType(4, this.tagSource, this.tagSourceId).pipe(first()).subscribe(
			(res:any) =>
			{
				if(res.data.tagJoin) {
					var tags = [];
					res.data.tagJoin.forEach(tag => {
						this.tagService.findById(tag.tagId).subscribe(
							(res:any) =>
							{
								tags.push(res.data.tag);
								this.tags = tags;
								this.tagSelectForm.patchValue({ tagJoin: tags });
							},
							error => {}
							);
					});
				}
			},
			error =>
			{
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}

	findTagsWith(queryString: string)
	{
		this.reportService.findTagsWith(queryString, this.tagSourceId).pipe(first()).subscribe(

			data =>
			{
				// console.log('tags are: ' + JSON.stringify(data));
				this.tagSuggestions = [];
				this.tagSuggestions = data.data.tagSummaryList;
				// console.log('QA: ' + JSON.stringify(this.tagSuggestions));
			},
			error =>
			{
				// console.log('reports LIST!: ' + JSON.stringify(error));
				this.alertService.error(error);
			},
			() =>
			{ }
		);
	}


	ngOnChanges()
	{
		// This is called when the parent updates. When the parent first initializes, it is in add state, and we have no tagSourceId.  This sets the tagSourceId when add is successful.
		if (this.tagSelectForm !== undefined)
		{
			this.tagSelectForm.patchValue({ tagSourceId: this.tagSourceId });
		}
	}
}
